import { render, staticRenderFns } from "./UpdateLang.vue?vue&type=template&id=bf4725a4&"
import script from "./UpdateLang.vue?vue&type=script&lang=ts&"
export * from "./UpdateLang.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateLang.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports